// Stripe + Calendly routing maps (single source of truth)

export const stripeLinks = {
  // MUSIC ARTIST
  music_f1_base:   "https://buy.stripe.com/6oUeVc6dL2XpdbE3pucMM00",
  music_f1_fast:   "https://buy.stripe.com/dRmbJ0gSp2Xp6NgbW0cMM01",
  music_f1_motion: "https://buy.stripe.com/00wcN4eKhcxZ2x0f8ccMM02",
  music_f1_bundle: "https://buy.stripe.com/4gM4gygSp2Xp9Zsf8ccMM03",

  music_f2_base:   "https://buy.stripe.com/14A14mdGdapR3B43pucMM04",
  music_f2_fast:   "https://buy.stripe.com/bJecN4gSp55x5Jc6BGcMM05",
  music_f2_motion: "https://buy.stripe.com/8x2bJ09pXcxZgnQ1hmcMM06",
  music_f2_bundle: "https://buy.stripe.com/eVq5kC9pXeG7fjMbW0cMM07",

  music_f3_base:   "https://buy.stripe.com/00w7sK7hPdC3gnQ4tycMM08",
  music_f3_fast:   "https://buy.stripe.com/7sYbJ07hP69B3B4bW0cMM09",
  music_f3_motion: "https://buy.stripe.com/bJeaEW45D9lN3B4d04cMM0a",
  music_f3_bundle: "https://buy.stripe.com/8x26oGeKh0Ph7RkgcgcMM0b",

  // SMALL BUSINESS
  biz_f1_base:     "https://buy.stripe.com/6oUaEWeKhdC3efIe48cMM0c",
  biz_f1_fast:     "https://buy.stripe.com/9B66oGfOl9lN9Zsd04cMM0d",
  biz_f1_bundle:   "https://buy.stripe.com/dRm8wOgSpfKbgnQe48cMM0e",

  biz_f2_base:     "https://buy.stripe.com/eVqaEWfOlapR4F87FKcMM0f",
  biz_f2_fast:     "https://buy.stripe.com/8x2eVc6dL55x8Vo6BGcMM0g",
  biz_f2_motion:   "https://buy.stripe.com/3cI14mby569B1sW2lqcMM0h",
  biz_f2_bundle:   "https://buy.stripe.com/6oU5kC1Xv9lNgnQd04cMM0i",

  biz_f3_base:     "https://buy.stripe.com/fZu28qcC9gOf1sWf8ccMM0j",
  biz_f3_fast:     "https://buy.stripe.com/6oUbJ0au17dF9Zs1hmcMM0k",
  biz_f3_motion:   "https://buy.stripe.com/eVq14m31z41t1sWd04cMM0l",
  biz_f3_bundle:   "https://buy.stripe.com/9B614mgSpapR2x0gcgcMM0m",

  // EVENTS
  event_f1_base:   "https://buy.stripe.com/4gM8wO8lT2Xp4F89NScMM0n",
  event_f1_fast:   "https://buy.stripe.com/9B67sK7hP1Tl3B44tycMM0o",
  event_f1_motion: "https://buy.stripe.com/28EdR845DbtV7Rk1hmcMM0p",
  event_f1_bundle: "https://buy.stripe.com/4gMaEWby5apRgnQe48cMM0q"
};

export const bookingLinks = {
  call_only: "https://calendly.com/thefrmlateam/30min"
};

/**
 * Get the Stripe checkout URL based on identity, formula, and selected upgrades
 * @param {string} identity - 'artist', 'business', or 'events'
 * @param {string} formula - '01', '02', or '03'
 * @param {Array} upgrades - Array of upgrade objects with id property
 * @returns {string} - Stripe checkout URL
 */
export function getStripeCheckoutUrl(identity, formula, upgrades = []) {
  // Map identity to prefix
  const identityMap = {
    artist: 'music',
    business: 'biz',
    events: 'event'
  };
  
  // Convert formula '01' -> '1', '02' -> '2', '03' -> '3'
  const formulaNum = parseInt(formula, 10);
  const prefix = `${identityMap[identity]}_f${formulaNum}`;
  
  // Determine variant based on upgrades
  let variant = 'base';
  
  if (upgrades.length >= 2) {
    variant = 'bundle';
  } else if (upgrades.length === 1) {
    const upgradeId = upgrades[0].id;
    if (upgradeId === 'fast-turnaround') {
      variant = 'fast';
    } else if (upgradeId === 'motion-graphics') {
      variant = 'motion';
    } else {
      // Other single upgrades default to base
      variant = 'base';
    }
  }
  
  const finalKey = `${prefix}_${variant}`;
  
  // Return the URL or fallback to base
  return stripeLinks[finalKey] || stripeLinks[`${prefix}_base`] || stripeLinks.music_f1_base;
}
